<template>
  <b-container id="ScannerCredentialContainer" class="mt-5 mb-5">
    <b-row style="justify-content: center">
      <div class="title">
        Agréger mon portefeuille
      </div>
      <div class="subtitle mt-4 mb-5">
        Pas encore de portefeuille ?
        <span><a href="/constructeur_portefeuille/selection_titres">Utilisez notre constructeur</a></span>
      </div>
    </b-row>
    <b-row class="mt-3">
      <div class="ScannerformContainer p-5">
        <div class="title ">
          Synchronisez vos comptes en sélectionnant les différents établissements que vous utilisez
        </div>
        <credentials-form :intermediaries="intermediaries" :platforms="platforms" :branchs="branchs" :investments="investments" :token="token" :route="route" />
      </div>
    </b-row>
    <b-row class="ScannerSecurityCard mt-5">
      <b-col cols="12" md="4" style="align-self:center;text-align: center;">
        <img style="width: 60%;transform: scaleX(-1);" :src="this.$path + 'companies.png'" alt="companies" />
      </b-col>
      <b-col cols="12" md="8" style="color:#707070;text-align:left">
        <div style="color:white">La sécurité de vos données, notre priorité</div>
        <div class="mt-3">
          Myfo, agrée par le Conseiller en Investissement Financier (CIF) s'engage à veiller à la sécurité de vos identifiants et mots de passes.
        </div>
        <div class="mt-3">Membre de l’ANACOFI-CIF, association agréée par l’AMF</div>
        <div class="mt-3">Numéro Orias : 20002629</div>
        <div class="mt-3" style="display: flex; justify-content:space-between;width: 100%;align-items: center;">
          <span>En savoir plus sur la sécurité</span> <span><Modal /></span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Modal from "./comps/Modal.vue";

export default {
  props: ["intermediaries", "platforms", "branchs", "investments", "token", "route"],
  components: { Modal },
};
</script>
<style lang="scss">
@import "../../../../sass/_variables.scss";
#ScannerCredentialContainer {
  width: 100%;
  .row {
    width: 100%;
  }

  a {
    color: $purple_color;
  }

  .modal-content {
    background: #121212 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
  }

  .d-flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: #ffffff;
    width: 100%;
    opacity: 1;
  }
  .subtitle {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_subtitle Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;
    width: 100%;
    opacity: 1;
    span {
      text-align: center;
      letter-spacing: 0px;
      color: #9561e2;
      opacity: 1;
    }
  }

  .ScannerformContainer {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    .title {
      text-align: center;
      font: normal normal normal $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: #ffffff;
      opacity: 1;
    }
  }
  .ScannerSecurityCard {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    align-items: center;
    width: 80%;
    margin: auto;padding: 20px;

    img {
      width: 200px;
    }
    .title {
      text-align: left;
      font: normal normal normal $mf_ft_size_subtitle Segoe UI;
      letter-spacing: 0px;
      color: #ffffff;
      opacity: 1;
    }
    .content {
      text-align: left;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: #707070;
      p {
        padding-top: 5px;
      }
      .last {
        text-align: left;
        font: normal normal normal $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: #9561e2;
      }
    }
  }
}
</style>
